module.exports = __webpack_public_path__ + "static/sport/footer.a731885.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/football/pc/footer.png
// module id = fm6l
// module chunks = 0